import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BrandLogo } from "@/components/base/BrandLogo";

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Products", path: "/products" },
    { label: "Services", path: "/services" },
    { label: "Contact", path: "/contact" },
  ];

  const handleNav = (path: string) => {
    navigate(path);
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <BrandLogo scrolled={scrolled} size="md" />

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNav(link.path)}
                className={`text-sm font-sans font-medium tracking-wide transition-colors hover:text-gold-500 cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-stone-700" : "text-white/90"
                }`}
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("/quote")}
              className="ml-4 px-5 py-2.5 bg-gold-500 text-white text-sm font-sans font-medium rounded-md hover:bg-gold-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get a Quote
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden p-2 cursor-pointer ${
              scrolled ? "text-stone-900" : "text-white"
            }`}
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-stone-200">
          <div className="px-4 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNav(link.path)}
                className="text-left text-stone-700 font-sans font-medium py-2 hover:text-gold-500 transition-colors cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("/quote")}
              className="mt-2 px-5 py-3 bg-gold-500 text-white text-sm font-sans font-medium rounded-md hover:bg-gold-600 transition-colors cursor-pointer"
            >
              Get a Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}